import React, { Component, useCallback } from "react";
import { withReportsList } from "../../../shared/containers/containerReportsList";
import { withCustomReport } from "../../../shared/containers/containerCustomReport";
import ReportFieldParametrConstructor from "./ReportFieldParametrConstructor";
import { states } from "../../../reducers/queriesStates";
import { v4 as uuidv4 } from "uuid";

import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { ReportFieldsDnDContainer } from "./ReportFieldsDnDContainer";

class ReportFieldsConstructor extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedField: null,

      shiftField: null,
      key: uuidv4(),
    };
  }

  componentDidUpdate(prevProps) {
    const { shiftCustomReportFieldDataState } = this.props;

    if (this.isUnselect(prevProps)) {
      this.setState({ selectedField: null, key: uuidv4() });
    }

    if (prevProps.shiftCustomReportFieldDataState === states.REQUEST && shiftCustomReportFieldDataState === states.READY) {
      const { shiftField } = this.state;
      this.onSelectToChange(shiftField);
    }
  }

  isUnselect(prevProps) {
    const { updateCustomReportFieldDataState, addCustomReportFieldDataState, deleteCustomReportFieldDataState } = this.props;

    return (
      (prevProps.updateCustomReportFieldDataState === states.REQUEST && updateCustomReportFieldDataState === states.READY) ||
      (prevProps.addCustomReportFieldDataState === states.REQUEST && addCustomReportFieldDataState === states.READY) ||
      (prevProps.deleteCustomReportFieldDataState === states.REQUEST && deleteCustomReportFieldDataState === states.READY)
    );
  }

  onSelectToChange(field) {
    const { selectedField } = this.state;

    if (selectedField === null || selectedField.id !== field.id) {
      this.setState({
        selectedField: field,
        shiftField: null,
      });
    }

    this.setState({ key: uuidv4() });
  }

  onChangeTitle(title) {
    const { selectedField } = this.state;

    if (selectedField !== null) {
      selectedField.dashboard.title = title;
      this.setState({ selectedField: selectedField, key: uuidv4() });
    }
  }

  onChangeCss(cssColumnWidth) {
    const { selectedField } = this.state;

    if (selectedField !== null) {
      selectedField.cssColumnWidth = cssColumnWidth;
      this.setState({ selectedField: selectedField, key: uuidv4() });
    }
  }

  onChangeExcel(excelColumnWidth) {
    const { selectedField } = this.state;

    if (selectedField !== null) {
      selectedField.excelColumnWidth = excelColumnWidth;
      this.setState({ selectedField: selectedField, key: uuidv4() });
    }
  }

  onUpdateField() {
    const { onUpdateCustomReportField, selectedCustomReportId } = this.props;
    const { selectedField } = this.state;

    if (selectedField !== null) {
      const options = {
        id: selectedField.id,
        title: selectedField.dashboard.title,
        excelColumnWidth: selectedField.excelColumnWidth,
        cssColumnWidth: selectedField.cssColumnWidth,
      };

      onUpdateCustomReportField(options, selectedCustomReportId);
    }
  }

  onShiftHandle(field, number) {
    const { onShiftCustomReportField, selectedCustomReportId } = this.props;
    onShiftCustomReportField({ id: field.id, number }, selectedCustomReportId);

    this.setState({ shiftField: field });
  }

  render() {
    const { fields, countFixFields } = this.props;
    const { selectedField, key } = this.state;

    return (
      <div>
        <div>Панель колонок:</div>
        <DndProvider backend={HTML5Backend}>
          <ReportFieldsDnDContainer
            key={key}
            fields={fields}
            selectedField={selectedField}
            countFixFields={countFixFields}
            onSelectHandle={this.onSelectToChange.bind(this)}
            onUpdateHandler={this.onUpdateField.bind(this)}
            onShiftHandle={this.onShiftHandle.bind(this)}
          />
        </DndProvider>

        {selectedField !== null && selectedField != undefined ? (
          <ReportFieldParametrConstructor
            key={selectedField.id}
            field={selectedField}
            countFixFields={countFixFields}
            onChangeTitleHahdle={this.onChangeTitle.bind(this)}
            onChangeCssHahdle={this.onChangeCss.bind(this)}
            onChangeExcelHahdle={this.onChangeExcel.bind(this)}
            onShiftHandle={this.onShiftHandle.bind(this)}
          />
        ) : null}
      </div>
    );
  }
}

export default withCustomReport(withReportsList(React.memo(ReportFieldsConstructor)));
